/* @flow */

import { rem } from 'polished';

import { darkTextColor } from '@e180/ui/lib/token/color';
import { topicFontFamily, baseFontSize } from '@e180/ui/lib/token/typography';

export default {
  root: {
    flex: '1',

    minHeight: 0,
  },
  title: {
    color: darkTextColor,

    fontFamily: topicFontFamily,
    fontSize: rem(22, baseFontSize),
    lineHeight: 1,
    wordWrap: 'break-word',
  },
  'title-withSeparator': {
    '&:after': {
      content: '""',

      display: 'block',

      width: 15,
      height: 1,
      marginTop: rem(10, baseFontSize),

      backgroundColor: darkTextColor,
    },
  },
  'title-hasOverflown': {
    fontSize: rem(19, baseFontSize),
  },
};
